'use client';

import React, { useEffect, useState } from 'react';

const ReadingProgress = () => {
  const [completion, setCompletion] = useState(0);

  useEffect(() => {
    const updateScrollCompletion = () => {
      const currentProgress = window.scrollY;
      const scrollHeight = document.body.scrollHeight - window.innerHeight;
      
      if (scrollHeight) {
        // Using a higher precision for smoother movement
        setCompletion((currentProgress / scrollHeight) * 100);
      }
    };

    window.addEventListener('scroll', updateScrollCompletion);
    return () => window.removeEventListener('scroll', updateScrollCompletion);
  }, []);

  return (
    /* top-16 places it right at the seam where the Navbar ends */
    <div className="fixed top-16 left-0 w-full h-[2px] z-[45] bg-transparent pointer-events-none">
      <div
        className="h-full bg-indigo-600 dark:bg-indigo-500 shadow-[0_0_10px_rgba(79,70,229,0.5)] transition-transform duration-150 ease-out origin-left"
        style={{ transform: `scaleX(${completion / 100})` }}
      />
    </div>
  );
};

export default ReadingProgress;